import { render, staticRenderFns } from "./SacroiliacInjections.vue?vue&type=template&id=6c220449&scoped=true"
import script from "./SacroiliacInjections.vue?vue&type=script&lang=js"
export * from "./SacroiliacInjections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c220449",
  null
  
)

export default component.exports